<div id="mfa">

  <h2 i18n>Authentication</h2>
  @if (loading()) {
    <div class="flex justify-content-center align-items-center" style="min-height: 200px;">
      <p-progressSpinner ariaLabel="Please wait..." strokeWidth="4" />
    </div>
  } @else {
    @if (mfaOption) {
      @switch (mfaOption) {
        @case ('sms') {
          <p i18n>Please check your SMS messages for your authentication code.</p>
        }
        @case ('totp') {
          <p i18n>Please enter the authentication code from your authenticator application.</p>
        }
        @default {
          <p i18n>Please check your email inbox for your authentication code.</p>
        }
      }
    }

    <div class="form">
      <div class="flex justify-content-center align-items-center mx-2">

        <p-inputOtp
          aria-label="One Time Passcode input"
          class="my-3"
          [(ngModel)]="form!.code"
          [length]="6"
          (keyup.enter)="login()"
        />
      </div>
      @if (form!.errors.code) {
        @if (form!.errors.code === 'INVALID_CODE') {

          @if (mfaOption) {
            @switch (mfaOption) {
              @case ('sms') {
                <p-message styleClass="mb-3" severity="error" closable i18n>Please enter the code that was sent to you
                  by SMS
                </p-message>
              }
              @case ('totp') {
                <p-message styleClass="mb-3" severity="error" closable i18n>Please enter the code from your
                  authenticator app
                </p-message>
              }
              @default {
                <p-message styleClass="mb-3" severity="error" closable i18n>Please enter the code that was sent to you
                  by email
                </p-message>
              }
            }
          } @else {
            <p-message styleClass="mb-3" severity="error" closable i18n>Please enter your MFA code, likely sent to you
              by email
            </p-message>
          }
        }
        @if (form!.errors.code === 'FAILED_TO_SEND') {
          <p-message styleClass="mb-3" severity="error" closable i18n>Failed to send code. Send New Code to try again
          </p-message>
        }
        <button class="p-button form-btn" (click)="login()">Verify</button>
        @if (mfaOption !== 'totp') {
          @if (sendingCode()) {
            <button class="p-button form-btn gap-2 secondary resend" disabled>
              <i class="pi pi-spinner pi-spin"></i> Sending...
            </button>
          } @else if (showResend()) {
            <button class="p-button form-btn gap-2 secondary resend" (click)="sendCode()">Send New Code</button>
          }
        }
      } @else {
        <button class="p-button form-btn gap-2" (click)="login()">Verify</button>
        @if (mfaOption !== 'totp') {
          @if (sendingCode()) {
            <button class="p-button form-btn gap-2 secondary resend" disabled>
              <i class="pi pi-spinner pi-spin"></i> Sending...
            </button>
          } @else if (showResend()) {
            <button class="p-button form-btn gap-2 secondary resend" (click)="sendCode()">Send New Code</button>
          }
        }
      }
    </div>
  }
</div>
